// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"161":"6b5371ac","439":"4a905ce3","823":"7d2d445c","867":"b8f081b0"}[chunkId] + ".css";
};